import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "chapter__intro" }
const _hoisted_2 = { "data-animation": "fadeIn" }
const _hoisted_3 = { "data-animation": "fadeUp" }


const __default__ = {
  name: 'ChapterIntro',
};


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  title: String,
  chapterNumber: Number,
  theme: String as () => 'light' | 'dark',
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h6", _hoisted_2, "Pillar " + _toDisplayString(__props.chapterNumber), 1),
    _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.title), 1)
  ]))
}
}

})